/**
 * وضعیتِ واحدِ تولید — تنها منبعِ حقیقتِ فرانت.
 *
 * قبلاً هر صفحه فهرستِ خودش را داشت («وضعیت» و «وضعیت دوخت» جدا) و با عوض‌شدنِ
 * بک‌اند از هم واگرا می‌شدند. مقادیر باید دقیقاً با `PROGRESS_*` در
 * `backend/app/services/production_rows.py` یکی بمانند.
 *
 * ترتیبِ آرایه = ترتیبِ واقعیِ کار = اولویتِ نمایش در لیست‌ها.
 */
export const PRODUCTION_STAGES = [
  { value: "new", label: "آماده دوخت", color: "blue",
    hint: "برش ثبت شده ولی هنوز عملیات دوختی ثبت نشده" },
  { value: "in_progress", label: "در حال دوخت", color: "orange",
    hint: "حداقل یک عملیات ثبت شده و کنترل اول هنوز تأیید نشده" },
  { value: "sewing_done", label: "دوخت تکمیل", color: "cyan",
    hint: "دستی علامت خورده: دوخت تمام و قفل است؛ کنترل اول/نهایی هنوز می‌تواند ثبت شود" },
  { value: "qc1", label: "کنترل اول", color: "purple",
    hint: "کنترل اول ثبت شده — دوخت قفل است" },
  { value: "qc2", label: "کنترل نهایی", color: "green",
    hint: "کنترل نهایی ثبت شده — این مرحلهٔ تولید تمام است" },
  { value: "done", label: "تکمیل", color: "gold",
    hint: "دستی علامت خورده: این تولید کلاً تمام است" },
];

export const STAGE_MAP = Object.fromEntries(PRODUCTION_STAGES.map((s) => [s.value, s]));
export const STAGE_RANK = Object.fromEntries(PRODUCTION_STAGES.map((s, i) => [s.value, i]));

/** مرحله‌هایی که دوختشان قفل است (عملیات جدید/ویرایش ممنوع) */
export const LOCKED_STAGES = ["sewing_done", "qc1", "qc2", "done"];
export const isSewingLocked = (stage) => LOCKED_STAGES.includes(stage);

/** برچسبِ فارسیِ یک وضعیت (ناشناخته ⇒ خودِ مقدار) */
export const stageLabel = (v) => STAGE_MAP[v]?.label || v || "—";

/**
 * وضعیتِ یک بیجک = عقب‌ترین مرحلهٔ محصولاتش.
 * بیجکی که یک پارتش هنوز دوخته نشده «آماده دوخت» است، نه «کنترل نهایی» —
 * چون کارِ باقی‌مانده باید دیده شود.
 */
export const groupStage = (products) => {
  const list = (products || []).map((p) => p.sewing_status).filter(Boolean);
  if (!list.length) return "new";
  return list.reduce((worst, s) =>
    ((STAGE_RANK[s] ?? 9) < (STAGE_RANK[worst] ?? 9) ? s : worst), list[0]);
};
